export const en = {
  // Navigation
  nav: {
    home: 'Home',
    services: 'Our Services',
    about: 'About Us',
    contact: 'Contact',
  },

  // Header
  header: {
    quote: 'Get Offer',
    quickQuote: 'Quick & Easy Offer',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
  },

  // Hero Carousel
  hero: {
    featured: 'Featured images',
    loading: 'Loading',
    noImages: 'No images found. Add to folder.',
    prev: 'Previous slide',
    next: 'Next slide',
    selector: 'Slide selector',
    goTo: 'Go to slide {0}',
    slide: 'Slide {0} / {1}',
    carouselImage: 'Carousel image {0}',
  },

  // About Section
  // About Section
  about: {
    companyLabel: 'TMR GLOBAL FOREIGN TRADE LTD.',
    title: 'ABOUT US',
    missionTitle: 'Our Goal',
    description: 'The company started its operations in 2022 with the export of construction machinery parts and electronic components. Later, it evolved into a structure that regularly supplies parts to Middle Eastern countries (Oman, Dubai, Egypt, etc.) by procuring various aircraft consumables from accredited aircraft companies in the USA and Europe. As of May 2025, as a member of the International Air Transport Association (IATA), it has become a global air cargo logistics provider, conducting air cargo transportation for all international buy-sell operations in-house.',
    buttonText: 'LEARN MORE',
    inventoryLabel: 'OUR SERVICES',
    inventoryTitle: 'SOLUTIONS',
    stats: {
      experience: { value: '3+', label: 'Years Experience' },
      global: { value: '10+', label: 'Countries Served' },
      clients: { value: '50+', label: 'Happy Clients' },
    },
  },

  // Tracking Section
  tracking: {
    title: 'Track Your Cargo',
    description: 'Enter your tracking number to find out where your cargo is',
    placeholder: 'Enter your tracking number (e.g., DEMO)',
    track: 'Track',
    searching: 'Searching...',
    error: 'Please enter tracking number',
    notFound: 'Cargo not found. Please type DEMO to see demo data.',
    hint: '💡 Type <strong>DEMO</strong> for demo',
    helpText: 'Need help?',
    trackingLabel: 'Tracking number',
    demoSteps: {
      step1: {
        title: 'Cargo Received',
        location: 'Ankara Warehouse',
      },
      step2: {
        title: 'At Airport',
        location: 'Esenboğa Airport',
      },
      step3: {
        title: 'In Transit',
        location: 'To Istanbul',
      },
      step4: {
        title: 'At Distribution Center',
        location: 'Istanbul Warehouse',
      },
      step5: {
        title: 'Delivery',
        location: 'Your Address',
      },
    },
    estimatedDelivery: 'November 25, 2025',
  },

  // Contact page & form
  contact: {
    formTitle: 'Send Us a Message',
    nameLabel: 'Full Name',
    namePlaceholder: 'Your full name',
    emailLabel: 'Email Address',
    emailPlaceholder: 'example@email.com',
    phoneLabel: 'Phone',
    phonePlaceholder: '+90 5XX XXX XX XX',
    subjectLabel: 'Subject',
    subjectPlaceholder: 'Subject of your message',
    messageLabel: 'Message',
    messagePlaceholder: 'Write your message here...',
    sendButton: 'Send Message',
    sending: 'Sending...',
    success: 'Your message was sent successfully.',
    error: 'An error occurred.',
  },

  // Quote Form
  quote: {
    cargoInfo: 'Cargo Information',
    contactInfo: 'Your Contact Information',
    cargoType: 'Select',
    cargoTypeLabel: 'Cargo Type',
    shipmentTypeLabel: 'Shipment Type',
    fromLabel: 'From',
    toLabel: 'To',
    weightLabel: 'Weight (KG)',
    volumeLabel: 'Volume (M³)',
    companyLabel: 'Company Name / Title',
    firstNameLabel: 'First Name',
    lastNameLabel: 'Last Name',
    emailLabel: 'Email Address',
    phoneLabel: 'Phone',
    messageLabel: 'Message',
    fromPlaceholder: 'Origin point',
    toPlaceholder: 'Destination point',
    weightPlaceholder: '0',
    volumePlaceholder: '0',
    companyPlaceholder: 'Company name',
    firstNamePlaceholder: 'Your first name',
    lastNamePlaceholder: 'Your last name',
    emailPlaceholder: 'example@email.com',
    phonePlaceholder: '+90 5XX XXX XX XX',
    messagePlaceholder: 'Additional information or special requests...',
    cancel: 'Cancel',
    submit: 'Submit Form',
    submitting: 'Submitting...',
    cargoTypes: {
      air: 'Air Cargo',
      road: 'Road Transport',
      sea: 'Sea Freight',
      express: 'Express',
    },
    shipmentTypes: {
      import: 'Import',
      export: 'Export',
      domestic: 'Domestic',
    },
  },

  // Footer
  footer: {
    company: 'Company',
    companyName: 'TMR GLOBAL',
    companySubtitle: 'Foreign Trade Ltd.',
    companyDescription: 'The company started its operations in 2022 with the export of construction machinery parts and electronic components. As of May 2025, as a member of the International Air Transport Association (IATA), it has become a global air cargo logistics provider.',
    socialLinks: 'Social media links',
    visitSocial: 'Visit our {0} page',
    contactTitle: 'CONTACT',
    companyInfoTitle: 'COMPANY INFO',
    footerNav: 'Footer navigation',
    legalLinks: 'Legal links',
    copyright: '© {0} TMR Global Foreign Trade Ltd. All Rights Reserved.',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    viewCertificate: 'View IATA Certificate',
    certificateTitle: 'IATA Certificate',
    close: 'Close',
    services: 'Services',
    getQuote: 'Get Offer',
  },

  // Pages
  pages: {
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive solutions in international logistics and transport',
    },
    contact: {
      title: 'Contact',
      subtitle: 'Get in touch with our logistics experts',
      sectionAria: 'Contact information and form',
    },
  },

  // About page structured data
  aboutPage: {
    hero: {
      title: 'About Us',
      subtitle: 'End-to-end solutions in global air cargo logistics and parts sourcing',
    },
    story: {
      title: 'Our Story',
      content: 'The company started operations in 2022 exporting construction machinery parts and electronic components. It later evolved into a supplier that procures various aircraft consumables from accredited aircraft companies in the USA and Europe and regularly supplies parts to Middle Eastern countries. As of May 2025, as a member of the International Air Transport Association (IATA), it became a global air cargo logistics provider, operating international air cargo transportation in-house.',
      highlights: [
        '2022: Started with construction machinery parts and electronic components',
        'Supply of consumables from accredited aircraft companies in the USA and Europe',
        'Regular parts supply to Middle Eastern countries (Oman, Dubai, Egypt, etc.)',
        'May 2025: IATA membership and in-house air cargo operations',
      ],
    },
    vision: {
      title: 'Our Vision',
      content: 'To be a trusted, sustainable and preferred partner in international supply and air cargo logistics; delivering end-to-end, transparent and timely operations that add value to our customers.',
      goals: [
        'Sustainable logistics practices',
        'Leadership in digital transformation',
        'Global network expansion',
        'Excellence in customer satisfaction',
      ],
    },
    mission: {
      title: 'Our Mission',
      content: 'To deliver aircraft consumables sourced from our accredited supply network in the USA and Europe to target markets, primarily in the Middle East, in a regular, safe and planned manner. In line with our IATA membership, we provide integrated air cargo logistics services by operating international air cargo transportation in-house.',
      values: [
        'Reliability and transparency',
        'Customer-focused service',
        'Quality and excellence',
        'Continuous improvement and innovation',
      ],
    },
    stats: [
      { number: '2022', label: 'Operations Started' },
      { number: '2025', label: 'IATA Membership (May)' },
      { number: 'USA & Europe', label: 'Accredited Supply Network' },
      { number: 'Middle East', label: 'Regular Parts Supply' },
    ],
  },

  // Components
  serviceCard: {
    details: 'Details',
    detailsAria: 'More details about {0}',
  },

  // Tracking Help
  trackingHelp: {
    or: 'or',
  },

  // Contact page & form
  contactForm: {
    title: 'Send Us a Message',
    success: 'Your message was sent successfully. We will get back to you shortly.',
    error: 'An error occurred. Please try again.',
    nameLabel: 'Full Name',
    emailLabel: 'Email Address',
    messageLabel: 'Message',
    namePlaceholder: 'Your full name',
    emailPlaceholder: 'example@email.com',
    messagePlaceholder: 'Write your message here...',
    submit: 'Send Message',
    submitting: 'Sending...',
  },

  // Contact info card
  contactInfo: {
    title: 'Contact Information',
    phoneLabel: 'Phone',
    emailLabel: 'Email',
    addressLabel: 'Address',
    mapPlaceholder: 'Map coming soon',
  },

  // Services data (translations for servicesData.json)
  servicesData: {
    services: [
      {
        id: 1,
        title: 'Aircraft Parts and Consumables Supply',
        icon: 'FiSettings',
        description: 'We reliably deliver aircraft spare parts and consumables sourced from accredited manufacturers in the USA and Europe to the global aviation sector, especially in the Middle East.',
        features: ['Accredited Supply Network', 'Fast Part Sourcing', 'AOG (Urgent) Services']
      },
      {
        id: 2,
        title: 'IATA Accredited Air Cargo Logistics',
        icon: 'FiSend',
        description: 'As a member of the International Air Transport Association (IATA), we manage all your air cargo operations with our in-house capabilities, fast and in compliance with standards.',
        features: ['Global IATA Network', 'Priority Cargo', 'Charter Solutions']
      },
      {
        id: 3,
        title: 'Construction Machinery & Electronics Export',
        icon: 'FiCpu',
        description: 'With our experience since 2022, we export construction machinery parts and sensitive electronic components smoothly with our expert team.',
        features: ['Sensitive Transport', 'Technical Expertise', 'Customs Support']
      },
      {
        id: 4,
        title: 'Transit Trade and Cross-Trade',
        icon: 'FiGlobe',
        description: 'We manage your trade between third countries via Turkey or directly; optimizing the supply chain between the USA, Europe, and the Middle East.',
        features: ['Third Country Transport', 'Document Management', 'Cost Optimization']
      }
    ]
  },


};
